import { getCommonAssetPath, getGeoAssetPath } from '../../geo/config'
import React, { memo, useEffect, useState } from 'react'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import styles from './styles.module.css'

interface WheelProps {
  isAnimate: boolean
  isOpenModal: number
  spinsCount: number
  disabled?: boolean
  onSpin: () => void
}

const Wheel: React.FC<WheelProps> = ({ isAnimate, spinsCount, disabled, onSpin }) => {
  const [rotateBorderDegree, setRotateBorderDegree] = useState(0)
  const { geo } = useGeoRuntime()
  const wheel = getGeoAssetPath(geo, 'wheel.webp')
  const wheelSpinImage = getCommonAssetPath('wheel_spin.webp')
  const wheelCrown = getCommonAssetPath('wheel_crown.webp')

  useEffect(() => {
    if (isAnimate) {
      if (spinsCount === 3) return setRotateBorderDegree(2875)
      if (spinsCount === 2) return setRotateBorderDegree(7980)
    } else {
      let i = 0
      setRotateBorderDegree((prev) => prev - 5)
      const interval = setInterval(() => {
        if (i % 2 === 0) setRotateBorderDegree((prev) => prev + 10)
        if (i % 2 === 1) setRotateBorderDegree((prev) => prev - 10)
        i++
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [isAnimate, spinsCount])

  return (
    <div
      data-cy="landing-wheel"
      className={styles.wheelContainer}
      onClick={!disabled ? onSpin : undefined}
    >
      <img className={styles.wheelCrown} src={wheelCrown} alt={'Wheel Crown'} />
      <img
        className={styles.wheel}
        style={{
          transform: `rotate(${rotateBorderDegree}deg)`,
          transitionDuration: isAnimate ? '3.5s' : '1s',
          transitionTimingFunction: isAnimate ? 'cubic-bezier(0.45, 0.04, 0.13, 1)' : 'ease-in-out',
        }}
        src={wheel}
        alt={'Wheel'}
      />
      <div data-cy="landing-wheel-arrow" className={styles.wheelSpinContainer}>
        <img className={styles.wheelSpin} src={wheelSpinImage} alt="Spin button" />
      </div>
    </div>
  )
}

export default memo(Wheel)
